import {
  Component,
  Input,
} from '@angular/core';
import {LookupService} from "../../srvs/lookup";

@Component({
  selector: 'micro-itsmObject-lookup',
  templateUrl: './micro-itsmObject-lookup.component.html'
})
export class MicroItsmObjectLookupComponent  {

  @Input()
  itsmObjectId:any;
}
